export const LINKS_GET_TYPES = `
    query _ {
        link_types {
            id
            type_name
        }
    }
`;
